import { BrowserModule } from '@angular/platform-browser';
import { NgModule } from '@angular/core';

import { AppComponent } from './app.component';
import { FormsModule } from '@angular/forms'

import { DisplayFormComponent } from './components/display-form/display-form.component';
import { RouterModule, Routes } from '@angular/router';
import { SelectionFormComponent } from './components/selection-form/selection-form.component';
import { DisplayFormService } from './components/display-form.service';
import { HttpClientModule } from '@angular/common/http';
import { LoginComponent } from './components/login/login.component';

import { BrowserAnimationsModule } from '@angular/platform-browser/animations';

import { GrowlModule } from 'primeng/growl';
import { MultiSelectModule } from 'primeng/multiselect';
import { CalendarModule } from 'primeng/calendar';
import { RadioButtonModule } from 'primeng/radiobutton';
import { DropdownModule } from 'primeng/dropdown';
import { DialogModule } from 'primeng/dialog';
import { TableModule } from 'primeng/table';
import { InputTextareaModule } from 'primeng/inputtextarea';
import { InputTextModule } from 'primeng/inputtext';
import { ButtonModule } from 'primeng/button';
import { FieldsetModule } from 'primeng/fieldset';
import { MsAdalAngular6Module } from 'microsoft-adal-angular6';
import { AuthenticationGuard } from 'microsoft-adal-angular6';
import { ConfirmDialogModule } from 'primeng/confirmdialog';
import { ConfirmationService } from 'primeng/api';

//Service
import { LoginService } from './services/login.service';
import { AppGlobals } from './app.global';

const appRoutes: Routes = [

  //SSO -start
  { path: '', component: SelectionFormComponent, pathMatch: 'full', canActivate: [AuthenticationGuard] },
  //SSO - end
  //  login - start
  //  { path: 'login', component: LoginComponent },
  //  { path: 'selection', component: SelectionFormComponent },
  //  { path: '**', component: LoginComponent }
  //login - end
];


@NgModule({
  declarations: [
    AppComponent,
    DisplayFormComponent,
    SelectionFormComponent,
    LoginComponent,
  ],
  imports: [
    RouterModule.forRoot(
      appRoutes,
      { enableTracing: true } // <-- debugging purposes only
    ),


    MsAdalAngular6Module.forRoot({
      tenant: 'massl.onmicrosoft.com',//'852c5799-8134-4f15-9d38-eba4296cc76f',
      clientId: 'f1aa2186-e4b2-4353-9f11-5d06ffd6ee62', //'f1aa2186-e4b2-4353-9f11-5d06ffd6ee62', 
      redirectUri: window.location.origin + '/',
      //postLogoutRedirectUri: window.location.origin + '/',
      //validateAuthority: true,
      endpoints: {
        "https://localhost:4200/API/": "xxx-bae6-4760-b434-xxx"
      },
      navigateToLoginRequestUrl: false,
      cacheLocation: 'localStorage',
    })
    ,

    BrowserModule,
    BrowserAnimationsModule,
    FormsModule,
    HttpClientModule,
    GrowlModule,
    CalendarModule,
    MultiSelectModule,
    RadioButtonModule,
    DropdownModule,
    DialogModule,
    TableModule,
    InputTextareaModule,
    InputTextModule,
    ButtonModule,
    FieldsetModule,
    ConfirmDialogModule
  ],
  exports: [
    RouterModule
  ],
  providers: [
    DisplayFormService,
    LoginService,
    AppGlobals,
    AuthenticationGuard,
    ConfirmationService
  ],
  bootstrap: [AppComponent],
})
export class AppModule { }
